<div *ngIf="status.active" [ngForm]="'vbDateTimePickerGroup' + index" layout-gt-md="row" layout-wrap="false" role="group" [attr.aria-label]="accessibilityLabel">
	<div [ngClass]="styles.dateContainer">
		<vb-ui-date-picker name="vbDTPDate" #date="ngModel" type="text" [(ngModel)]="internalModel.date" [ngClass]="styles.datePicker" [accessibilityLabel]="'DateTimePicker_DateInput' | translate" (ngModelChange)="onChildChange()">
		</vb-ui-date-picker>
	</div>

	<div flex="25" uiControl>
		<timepicker name="vbDTPTime" #time="ngModel" type="text" [(ngModel)]="internalModel.time" [minuteStep]="minuteStep" [showMeridian]="!is24Hr" [meridians]="meridiems" (isValid)="setTimeValid($event)" (ngModelChange)="onChildChange()">
		</timepicker>
	</div>
</div>
